import React from "react";
import NoRecord from "../../components/other/NoRecord";

const DirectoryList = ({ robotData = [], isDetailed = true }) => {
  return (
    <>
      <div className="untree_co-section product-section py-5 my-5">
        <div className="container">
          {isDetailed && (
            <div className="row">
              <div className="col-md-12">
                <h2 className="section-title text-center pb-5">
                  <strong>Team Directory</strong>
                </h2>
              </div>
            </div>
          )}
          <div className="row">
            {robotData && robotData?.length > 0 ? (
              robotData?.map((robot) => (
                <div key={robot?.id} className="col-lg-3 mb-4 col-md-6">
                  <div className="ct_robot_directory_card">
                    <figure>
                      <div className="ct_robot_directory_img">
                        <img
                          src={robot?.imgSrc}
                          alt={`${robot?.name} Thumbnail`}
                        />
                      </div>
                      {isDetailed && (
                        <figcaption>
                          <h4>{robot?.name}</h4>
                          <div>
                            <p className="mb-1">Robot Score</p>
                            <div className="progress">
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: `${robot?.score}%` }}
                                aria-valuenow={robot?.score}
                                aria-valuemin="0"
                                aria-valuemax="100"
                              >
                                {robot?.score}%
                              </div>
                            </div>
                          </div>
                        </figcaption>
                      )}
                    </figure>
                  </div>
                </div>
              ))
            ) : (
              <NoRecord />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectoryList;
